import { Button, Form } from "reactstrap";
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faSave, faTimes } from "@fortawesome/free-solid-svg-icons";

export default function ModalFormMateri({
  show,
  onHide,
  editMateriId,
  formMateri,
  handleChangeFormMateri,
  handleSubmitMateri,
  isSubmittingMateri,
  selectedMatpel,
  currentCpData,
  tpDataByCp,
  isFetchingTp,
  handleChangeKelasMateri,
  handleSelectAllKelasMateri,
}) {
  const tpOptions =
    formMateri.ysb_matpel_cp_id && tpDataByCp?.[formMateri.ysb_matpel_cp_id]
      ? tpDataByCp[formMateri.ysb_matpel_cp_id]
      : [];

  const selectedKelas = Array.isArray(formMateri.ysb_kelas_id)
    ? formMateri.ysb_kelas_id
    : [];

  const kelasList = selectedMatpel?.kelas_list || [];

  const isAllKelasSelected =
    kelasList.length > 0 &&
    kelasList
      .map((kelas) => kelas?.ysb_kelas_id)
      .filter(Boolean)
      .every((kelasId) => selectedKelas.includes(kelasId));

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="modal-materi"
      centered
      backdrop="static"
      keyboard={false}
    >
      <div className="d-flex header-modal">
        <h5>{editMateriId ? "Update Materi" : "Buat Materi"}</h5>

        <div className="ml-auto x-close">
          <FontAwesomeIcon icon={faTimes} onClick={onHide} />
        </div>
      </div>

      <hr />

      <Modal.Body className="modal-body">
        <Form onSubmit={handleSubmitMateri}>
          <div className="row">
            <div className="col-md-12">
              <div className="mt-3 label-group-form">
                <label className="label-name-form">Judul</label>
                <input
                  className="label-input-form"
                  autoFocus
                  type="text"
                  name="title"
                  placeholder="Masukkan judul materi"
                  value={formMateri.title}
                  onChange={handleChangeFormMateri}
                  disabled={isSubmittingMateri}
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="mt-4 label-group-form">
                <label className="label-name-form">CP</label>
                <select
                  className="label-input-form"
                  name="ysb_matpel_cp_id"
                  value={formMateri.ysb_matpel_cp_id}
                  onChange={handleChangeFormMateri}
                  disabled={isSubmittingMateri}
                >
                  <option value="">Pilih CP</option>
                  {(currentCpData || []).map((cp) => (
                    <option key={cp.id} value={cp.id}>
                      {cp.nama_cp}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-md-6">
              <div className="mt-4 label-group-form">
                <label className="label-name-form">TP</label>
                
                <select
                  className="label-input-form"
                  name="ysb_matpel_tp_id"
                  value={formMateri.ysb_matpel_tp_id}
                  onChange={handleChangeFormMateri}
                  disabled={isSubmittingMateri || isFetchingTp}
                >
                  <option value="">
                    {isFetchingTp ? "Memuat TP..." : "Pilih TP"}
                  </option>

                  {tpOptions.map((tp) => (
                    <option key={tp.id} value={tp.id}>
                      {tp.tp}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-md-12">
              <div className="mt-4">
                <div
                  className="d-flex"
                  style={{
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 10,
                    marginBottom: 10,
                  }}
                >
                  <label
                    style={{
                      color: "#374151",
                      fontWeight: 700,
                      marginBottom: 0,
                    }}
                  >
                    Kelas
                  </label>

                  {(selectedMatpel?.kelas_list || []).length > 0 && (
                    <button
                      type="button"
                      onClick={handleSelectAllKelasMateri}
                      disabled={isSubmittingMateri}
                      style={{
                        border: "none",
                        background: "transparent",
                        color: "#3f5bea",
                        fontWeight: 700,
                        fontSize: 13,
                        cursor: "pointer",
                      }}
                    >
                      Pilih Semua
                    </button>
                  )}
                </div>

                <div
                  style={{
                    border: "1px solid #9bb5ff",
                    borderRadius: 12,
                    padding: "12px 14px",
                    minHeight: 52,
                    background: "#fff",
                  }}
                >
                  {(selectedMatpel?.kelas_list || []).length > 0 ? (
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
                        gap: 10,
                      }}
                    >
                      {(selectedMatpel?.kelas_list || []).map((kelas, index) => {
                        const kelasId = kelas?.ysb_kelas_id || "";
                        const isChecked = Array.isArray(formMateri.ysb_kelas_id)
                          ? formMateri.ysb_kelas_id.includes(kelasId)
                          : false;

                        return (
                          <label
                            key={kelasId || index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                              marginBottom: 0,
                              color: isChecked ? "#3f5bea" : "#374151",
                              fontWeight: 600,
                              cursor: isSubmittingMateri ? "not-allowed" : "pointer",
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={isChecked}
                              onChange={() => handleChangeKelasMateri(kelasId)}
                              disabled={isSubmittingMateri || !kelasId}
                            />
                            {kelas?.nama_kelas || "-"}
                          </label>
                        );
                      })}
                    </div>
                  ) : (
                    <div
                      style={{
                        color: "#6b7280",
                        fontWeight: 600,
                        fontSize: 13,
                      }}
                    >
                      Kelas belum tersedia
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="mt-4">
                <label
                  style={{
                    display: "block",
                    color: "#374151",
                    fontWeight: 700,
                    marginBottom: 8,
                  }}
                >
                  Diskusi
                </label>

                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    fontWeight: 600,
                    color: "#3f5bea",
                  }}
                >
                  <input
                    type="checkbox"
                    name="discuss"
                    checked={formMateri.discuss}
                    onChange={handleChangeFormMateri}
                    disabled={isSubmittingMateri}
                  />
                  Dibuka
                </label>
              </div>
            </div>

            <div className="col-md-6">
              <div className="mt-4">
                <label
                  style={{
                    display: "block",
                    color: "#374151",
                    fontWeight: 700,
                    marginBottom: 8,
                  }}
                >
                  Notifikasi
                </label>

                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    fontWeight: 600,
                    color: "#3f5bea",
                  }}
                >
                  <input
                    type="checkbox"
                    name="notofication"
                    checked={formMateri.notofication}
                    onChange={handleChangeFormMateri}
                    disabled={isSubmittingMateri}
                  />
                  Ya
                </label>
              </div>
            </div>

            <div className="col-md-12">
              <div className="mt-4 label-group-form">
                <label className="label-name-form">Isi Materi</label>
                <input
                  className="label-input-form"
                  autoFocus
                  type="text"
                  name="description"
                  placeholder="Materi"
                  value={formMateri.description}
                  onChange={handleChangeFormMateri}
                  disabled={isSubmittingMateri}
                />
              </div>
            </div>

            <div className="col-md-12">
              <div className="mt-4 label-group-form">
                <label className="label-name-form">File Materi</label>
                <input
                  className="label-input-form"
                  type="file"
                  name="file_material"
                  onChange={handleChangeFormMateri}
                  disabled={isSubmittingMateri}
                />
              </div>
            </div>
          </div>

          <div
            className="d-flex mt-4"
            style={{
              justifyContent: "flex-end",
              gap: 10,
              flexWrap: "wrap",
            }}
          >
            <button
              type="button"
              className="btn btn-light"
              onClick={onHide}
              disabled={isSubmittingMateri}
              style={{
                borderRadius: 10,
                fontWeight: 600,
                padding: "8px 10px",
                fontSize: "14px"
              }}
            >
              Batal
            </button>

            <button
              type="submit"
              className="btn btn-modal-create"
              disabled={isSubmittingMateri}
              style={{
                borderRadius: 12,
                padding: "8px 10px",
                boxShadow: "0 10px 24px rgba(108,99,255,0.18)",
                fontWeight: 600,
              }}
            >
              {isSubmittingMateri ? (
                // <PulseLoader color={"#fff"} size={8} />
                <i className="fa fa-spinner fa-spin mr-2" />
              ) : (
                <>
                  <FontAwesomeIcon icon={faPlus} />{" "}
                  {editMateriId ? "Perbarui" : "Tambahkan"}
                </>
              )}
            </button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}